import { TopolStyle } from "../schemas/template/styleSchema";

export const templateStyle: TopolStyle = {
  h1: {
    "font-family": "Helvetica, Arial, sans-serif",
    "font-size": "22px",
    "font-weight": "bold",
  },
  a: { color: "#0000EE" },
  h2: {
    "font-family": "Helvetica, Arial, sans-serif",
    "font-size": "17px",
    "font-weight": "bold",
  },
  h3: {
    "font-family": "Helvetica, Arial, sans-serif",
    "font-size": "13px",
    "font-weight": "bold",
  },
  p: { "font-family": "Helvetica, Arial, sans-serif", "font-size": "11px" },
  ul: {
    "font-size": "11px",
    "font-family": "Helvetica, Arial, sans-serif",
    "list-style-type": "disc",
  },
  li: {
    "font-size": "11px",
    "font-family": "Helvetica, Arial, sans-serif",
  },
  ol: {
    "font-size": "11px",
    "font-family": "Helvetica, Arial, sans-serif",
    "list-style-type": "decimal",
  },
  ".rounded>table": {
    "border-collapse": "separate",
  },
};
